@if (prestatie$ | async; as prestatie) {
  @if (client$ | async; as client) {
    @if (thuisverzorger$ | async; as thuisverzorger) {
      @if (diensten$ | async; as diensten) {
        <zah-client-header [client]="client"
          label="Kies dienst">
        </zah-client-header>
        <div class="content">
          <zah-prestatie-diensten [diensten]="diensten.filterForThuisverzorgerAtClient(thuisverzorger, client)"
            (dienstClicked)="navigateToTaken(prestatie, $event)">
          </zah-prestatie-diensten>
        </div>
      }
    }
  }
}
